



































import Vue from 'vue'
import Component from 'vue-class-component'
import HttpError from '@/shared/components/http-error.vue'
import RespondecoEditItemBar from '@/main/respondeco-edit-item-bar.vue'
import ProjectHeaderImage from '@/business/project/components/project-header-image.vue'
import ProjectHeader from '@/business/project/components/project-header.vue'
import ProjectDescription from '@/business/project/components/project-description.vue'
import ProjectPartners from '@/business/project/components/project-partners.vue'
import ProjectGallery from '@/business/project/components/project-gallery.vue'
import ProjectLearnings from '@/business/project/components/project-learnings.vue'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import { Prop } from 'vue-property-decorator'
import { environmentConfiguration } from '@/config/environments'
import { Injector } from '@/config/dependency-injection'
import { MetaService } from '@/shared/services/meta-service'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import { userIsAuthenticated } from '@/shared/utils/user'
import { imageUrl } from '@/shared/utils/images'
import { ProjectService } from '@/business/project/project-service'
import { ProjectResponse } from '@/api/generated'

@Component({
  name: 'offer-report',
  components: {
    RespondecoLoadingIndicator,
    ProjectLearnings,
    ProjectGallery,
    ProjectPartners,
    ProjectDescription,
    ProjectHeader,
    ProjectHeaderImage,
    RespondecoEditItemBar,
    HttpError,
  },
})
export default class OfferReport extends Vue {
  @Prop({
    required: true,
    type: Number,
  })
  public readonly offerId!: number

  public branding = environmentConfiguration().branding
  public loading = true
  public imageUrl = imageUrl
  public report: ProjectResponse | null = null

  private metaService = Injector.get(MetaService)
  private projectService = Injector.get(ProjectService)

  public get organisation(): OrganisationLite {
    return this.report!.organisation
  }

  public get userIsAuthenticated(): boolean {
    return userIsAuthenticated()
  }

  public mounted() {
    this.projectService.getOfferReport(Number(this.offerId)).then(report => {
      this.loading = false
      this.report = report

      this.metaService.updateDocumentTitle('project', {
        name: report.name,
      })
    })
  }
}
